export enum EInstitutionsSearchDataKeys {
  locationIds = 'locationIds',
}
